import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { locale as italian } from "../../../../../i18n/it";
import { DocumentsService } from "../../../../../auth/service/documents.service";
import { AuthenticationService } from "../../../../../auth/service";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-documents-categories",
  templateUrl: "./documents-categories.component.html",
  styleUrls: ["./documents-categories.component.scss"],
})
export class DocumentsCategoriesComponent implements OnInit {
  public contentHeader: IContentHeader;

  public searchKeyword: string = "";

  public tableLimit: number = 10;

  public categoriesList: any = [];

  public currentDocumentCategories: any;

  public newDocumentCategory: string = "";

  public isAChild: boolean = false;

  public selectedAsAParent: any;

  public pageBasicText: any = 1;

  public pageSize = 10;

  public showModalError: boolean = false;

  constructor(
    public _documentService: DocumentsService,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    private router: Router,
  ) {
    this.contentHeader = {
      headerTitle: italian.data.MENU.DOCUMENTS_CATEGORIES,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.DOCUMENTS_CATEGORIES,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this._utilService.showLoading();
    await this.loadCategories();
    this._utilService.hideLoading();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadCategories() {
    this.categoriesList = await this._documentService.getCategoriesList();
  }

  categoriesFilterList() {
    let items = this.categoriesList;

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.categoriesList.filter((item: any) => item.name.toLowerCase().includes(keywords));
    }
    return items;
  }

  public modalOpen(whichModal, documentCategory) {
    if (documentCategory && documentCategory.parent_id && documentCategory.parent_id > 0) {
      documentCategory.isAChild = 1;
    }
    this._modalService.open(whichModal, {
      size: "sm",
      centered: true,
    });
    this.showModalError = false;
    this.selectedAsAParent = null;
    this.newDocumentCategory = "";
    this.isAChild = false;
    this.currentDocumentCategories = JSON.parse(JSON.stringify(documentCategory));
  }

  async deleteDocumentCategory(currentCategory) {
    if (!this._authenticationService.hasCapability("delete_document_category")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentCategory.name;
    if (currentCategory) {
      await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
        if (result.value) {
          await this._documentService
            .deleteCategory(currentCategory.id)
            .then(async () => {
              await this._utilService.showPopupItemDeleted().then(async () => {
                await this.loadCategories();
              });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DOCUMENTS_CATEGORY_REMOVE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
    }
  }

  async addDocumentCategory() {
    if (!this._authenticationService.hasCapability("create_document_category")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.newDocumentCategory) {
      this.newDocumentCategory = this.newDocumentCategory.trim();
    }

    if (!this.newDocumentCategory || this.newDocumentCategory.length < 1) {
      this.showModalError = true;
      return false;
    }

    if (this.isAChild && (!this.selectedAsAParent || this.selectedAsAParent < 1)) {
      this.showModalError = true;
      return false;
    }

    this._utilService.showLoading();
    await this._documentService
      .createCategory({
        name: this.newDocumentCategory,
        parent_id: this.isAChild ? this.selectedAsAParent : null,
      })
      .then(() => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_ADD_DOCUMENTS_CATEGORY" });
        this.loadCategories();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_ADD_DOCUMENTS_CATEGORY" });
      });
  }

  async editDocumentCategory() {
    if (!this._authenticationService.hasCapability("edit_document_category")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!!this.currentDocumentCategories.name) {
      this.currentDocumentCategories.name = this.currentDocumentCategories.name.trim();
    }

    if (!this.currentDocumentCategories.name || this.currentDocumentCategories.name.length < 1) {
      this.showModalError = true;
      return false;
    }

    if (this.currentDocumentCategories.isAChild && (!this.currentDocumentCategories.parent_id || this.currentDocumentCategories.parent_id < 1)) {
      this.showModalError = true;
      return false;
    }

    if (this.currentDocumentCategories.isAChild === false) {
      await this._documentService
        .updateCategory(this.currentDocumentCategories.id, {
          name: this.currentDocumentCategories.name,
          parent_id: null,
        })
        .then(async () => {
          this._utilService.hideLoading();
          this._modalService.dismissAll();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_DOCUMENTS_CATEGORY" });
          await this.loadCategories();
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_EDIT_DOCUMENTS_CATEGORY" });
        });
    } else {
      await this._documentService
        .updateCategory(this.currentDocumentCategories.id, {
          name: this.currentDocumentCategories.name,
          parent_id: this.currentDocumentCategories && this.currentDocumentCategories.parent_id && this.currentDocumentCategories.parent_id > 0 ? this.currentDocumentCategories.parent_id : null,
        })
        .then(async () => {
          this._utilService.hideLoading();
          this._modalService.dismissAll();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_DOCUMENTS_CATEGORY" });
          await this.loadCategories();
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_EDIT_DOCUMENTS_CATEGORY" });
        });
    }
  }
}
